// extracted by mini-css-extract-plugin
export default {"container":"Tables_container__COTPo","link-active":"Tables_link-active__OdkWG"};